// Stub for vue-ripple-directive (not available for Vue 3)
// Ripple effect can be achieved with CSS

const Ripple = {
  mounted(el) {
    el.style.position = "relative"
    el.style.overflow = "hidden"

    el.addEventListener("click", (e) => {
      const rect = el.getBoundingClientRect()
      const ripple = document.createElement("span")
      const size = Math.max(rect.width, rect.height)

      ripple.style.cssText = `
        position: absolute;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.3);
        pointer-events: none;
        width: ${size}px;
        height: ${size}px;
        left: ${e.clientX - rect.left - size / 2}px;
        top: ${e.clientY - rect.top - size / 2}px;
        transform: scale(0);
        animation: ripple-effect 0.6s ease-out;
      `

      el.appendChild(ripple)
      setTimeout(() => ripple.remove(), 600)
    })
  },
}

export default Ripple
